export default "__VITE_ASSET__fAHPGWhF__"